
const Footer = () => {

  return (
    <>
      <footer className="footer-distributed">
        <div className="footer-left">
          <img
            className="mb-3"
            src="/img/landing/girlPower/brand/Imagotipo secundario contraste oscuro.jpg"
            alt="Logo GirlPower"
            width="70%"
            height="70%"
          />

          <p className="footer-company-name mt-4 d-none d-md-block">
            Desarrollado por: Educlick &copy; 2018
          </p>
          <p className="footer-company-name d-none d-md-block">322 243 42 96</p>
        </div>

        <div className="footer-center">
          <div>
            <a
              href="https://goo.gl/maps/SZKV84zvwuorBJha8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-map-marker m-0"></i>
              <p>
                <span>Av. Esperanza #75-25</span> Modelia, Bogotá
              </p>
            </a>
          </div>

          <div>
            <a
              href="https://api.whatsapp.com/send?phone=573123781174&text=Hola,%20quiero%20conocer%20Girl%20Power&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-phone m-0"></i>
              <p>312 378 11 74</p>
            </a>
          </div>
        </div>

        <div className="footer-right">
          <a
            href="https://www.instagram.com/girlpowerstudio/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram m-0" style={{ fontSize: "25px" }}></i>
            <p>@girlpowerstudio</p>
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
